module.exports = __webpack_public_path__ + "assets/fonts/rating-star-1.39cd8332.svg";